import {useCallback} from 'react';
import globalDomains from '@/utils/global-domains';

const useSoopiExitMessage = () => {
  const sendSoopiExitMessage = useCallback(async () => {
    const message = JSON.stringify({data: {cmd: 'soopiExit'}});
    const url = globalDomains.VOD_AFREECATV;

    const frame = document.getElementById('soopiPreviewPlayer');

    if (frame && frame.contentWindow) {
      frame.contentWindow.postMessage(message, url);

      try {
        await new Promise((resolve, reject) => {
          const timeout = setTimeout(() => {
            window.removeEventListener('message', handler);
            reject(new Error('Timeout: no soopiExitSuccess received'));
          }, 5000);

          const handler = (event) => {
            if (event.origin !== url) return;

            const data =
              typeof event.data === 'string'
                ? JSON.parse(event.data)
                : event.data;

            if (data?.cmd === 'soopiExitSuccess') {
              clearTimeout(timeout);
              window.removeEventListener('message', handler);
              resolve(true);
            }
          };

          window.addEventListener('message', handler);
        });
      } catch (err) {
        console.error('메시지 응답 실패:', err);
        throw err;
      }
    } else {
      console.warn('iframe not found or not ready');
    }
  }, []);

  return {sendSoopiExitMessage};
};

export default useSoopiExitMessage;
